import { PHONE, locationSchema } from "../structured-data-core";

export function getIndependenceStructuredData() {
  const url = "https://restorehair.com/locations/ohio/independence/";
  const description =
    "Find out about your hair transplant options in Independence with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Independence", "6100 Oak Tree Boulevard, Suite 200", "Independence", "OH", PHONE, url, description),
  ];
}
